module.exports = __webpack_public_path__ + "media/Paybycheck@2x.eca5f438.png";